module.exports = __webpack_public_path__ + "static/media/sun.7f93fbdb.svg";